<template>
  <section class="resume__footer">
    <div class="resume__footer__item">
      <SvgLogoCube class="footer__logo"></SvgLogoCube>
    </div>
    <div class="resume__footer__item">
      <div class="footer__contact" ref="contact">
        <p class="footer__contact__item">brandon@metawerks.net</p>
        <p class="footer__contact__item">Dallas, TX 75208</p>
        <p class="footer__contact__item">214.727.0680</p>
      </div>
    </div>
    <div class="resume__footer__item">
      <a target="_blank" href="https://www.linkedin.com/in/brandonsmith23/"
        ><SvgIconLinkedIn class="footer__icon"></SvgIconLinkedIn
      ></a>
      <a
        class="footer__link__text"
        href="https://www.linkedin.com/in/brandonsmith23/"
        ><p>Connect on LinkedIn</p></a
      >
    </div>
    <div class="resume__footer__item">
      <a href="#"><SvgIconPdf class="footer__icon"></SvgIconPdf></a>
      <a class="footer__link__text" href="#"><p>Download Resume</p></a>
    </div>
    <!-- <div class="resume__footer__item">
      <div class="footer__settings">
        <div class="theme__wrapper" ref="settings">
          <ThemeButton></ThemeButton>
        </div>
        <div class="header__settings__toggle" @click="toggleSettings()">
          <p>Mode</p>
          <SvgIconGear></SvgIconGear>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
  import SvgLogoCube from "@/components/svg/SvgLogoCube.vue"
  import SvgIconGear from "@/components/svg/SvgIconGear.vue"
  import SvgIconLinkedIn from "@/components/svg/SvgIconLinkedIn"
  import SvgIconPdf from "@/components/svg/SvgIconPdf"
  import ThemeButton from "@/components/ThemeButton.vue"
  export default {
    name: "ResumeFooter",
    components: {
      SvgLogoCube,
      SvgIconGear,
      SvgIconLinkedIn,
      SvgIconPdf,
      ThemeButton,
    },
    data() {
      return {}
    },
    methods: {
      toggleContact() {
        this.$refs.contact.classList.toggle("active")
      },
      toggleToggle() {
        this.$refs.toggle.classList.toggle("active")
      },
      toggleSettings() {
        this.$refs.settings.classList.toggle("active")
      },
    },
  }
</script>

<style lang="scss">
  @import "./src/scss/style--light";

  .resume__footer {
    margin-top: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  // .resume__footer__item:last-child {
  //   margin-left: auto;
  // }

  .footer__logo {
    width: 60px;
  }

  .footer__icon {
    width: 34px;
  }

  .resume__footer .icon--gear {
    width: 20px;
    margin-left: 0.25rem;
  }

  .footer__settings p {
    color: rgba(var(--text-tertiary), 1);
    font-size: 0.8rem;
  }

  .footer__contact__item {
    margin: 0;
    padding: 0.125rem 0 0.125rem 0rem;
    font-size: 0.8rem;
    color: rgba(var(--text-tertiary), 1);
  }

  .resume__footer__item {
    display: flex;
    padding: 0 0.5rem;
    min-height: 60px;
    align-items: center;
  }

  .resume__footer__item:nth-of-type(2),
  .resume__footer__item:nth-of-type(3) {
    border-right: 1px solid rgba(var(--text-tertiary), 0.5);
  }

  .resume__footer__item:nth-of-type(3),
  .resume__footer__item:nth-of-type(4) {
    padding: 0.25rem 1rem;
  }

  .footer__link__text {
    font-size: 0.8rem;
    margin-left: 0.25rem;
    color: rgba(var(--text-secondary), 1);
    text-decoration: none;
    transition: all 0.5s ease;
  }

  .footer__link__text:hover {
    text-decoration: underline;
    color: rgba(var(--text-primary), 1);
  }

  // .footer__settings {
  //   margin-left: auto;
  // }
</style>
